export const isTransientRequestFailure = (error) => {
    if (!error || error.code === 'ERR_CANCELED' || error.name === 'AbortError' || error.__CANCEL__) return false;
    const status = error.response?.status;
    if (status) return status === 408 || status === 429 || (status >= 500 && status < 600);
    return ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT', 'auth/network-request-failed'].includes(error.code) ||
        Boolean(error.request && !error.response);
};

export const withTransientRetry = async (operation, { shouldContinue = () => true } = {}) => {
    for (let attempt = 0; attempt < 2; attempt += 1) {
        if (!shouldContinue()) {
            const error = new Error('Request cancelled.');
            error.code = 'ERR_CANCELED';
            throw error;
        }
        try {
            return await operation();
        } catch (error) {
            if (attempt || !shouldContinue() || !isTransientRequestFailure(error)) throw error;
            await new Promise(resolve => setTimeout(resolve, 1000));
        }
    }
};
